module.exports = "<p>\n  item-stand-suggestion works!\n</p>\n"